// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5864":"a0b08d1c71ac7bf1","91859":"02ed36b24369dbb4","92490":"0f671e46949c77ed","94566":"e985141a315706f2"}[chunkId] + ".css";
};